"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NAME = exports.FieldValueConstraint = void 0;
const lodash_1 = require("lodash");
const AbstractConstraint_1 = require("./AbstractConstraint");
/**
 * This constraint checks that the value retrieved a specified path has a specific value.
 * Nested keys must be separated with a dot.
 * Configuration:
 * * type: 'FIELD_VALUE'
 * * path: 'path.to.your.field'
 * * value: 'value.to.be.enforced'
 */
class FieldValueConstraint extends AbstractConstraint_1.AbstractConstraint {
    /**
     * Returns true if the value retrieved at the configured path has the value specified into the configuration
     * @param data a dictionary containing the data to be validated
     * @returns {boolean}
     */
    isRespected(data) {
        return lodash_1.get(data, this.config.path) === this.config.value;
    }
}
exports.FieldValueConstraint = FieldValueConstraint;
exports.NAME = 'FIELD_VALUE';
//# sourceMappingURL=FieldValueConstraint.js.map